import 'core-js/stable';
import 'regenerator-runtime/runtime';

import React from 'react';
import { createRoot } from 'react-dom/client'; 
import { store, history } from './store/configureStore';
import Root from './components/App/Root';

const rootElement = document.getElementById('app');
const root = createRoot(rootElement);  
root.render(<Root store={store} history={history} />);  
